<ngx-loading-bar ref="http"></ngx-loading-bar>
<div *ngIf="isShow" class="wb-header">
  <app-header></app-header>
</div>
<div class="container">
  <div class="wb-content mt-5">
    <app-menu-top></app-menu-top>
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
